import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MawListComponent } from './maw-list/maw-list.component';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { PalletCreationComponent } from './pallet-creation/pallet-creation.component';
import { PalletDetailsComponent } from './pallet-details/pallet-details.component';
import { LinkPiecesComponent } from './link-pieces/link-pieces.component';
import { DgContentComponent } from './maw-list/dg-content/dg-content.component';
@NgModule({
  declarations: [
    MawListComponent,
    PalletCreationComponent,
    PalletDetailsComponent,
    LinkPiecesComponent,
    DgContentComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    CoreModule,
  ],
})
export class MawModule {}
